import React from 'react';
import FadeContent from '../components/FadeContent';
import MediaCarousel from '../components/MediaCarousel';
import { realisationsSlides } from './realisationsSlides';
import { Link } from 'react-router-dom';

const Gallery = () => {
  return (
    <div className="gallery-page">
      <section className="gallery-hero" aria-labelledby="gallery-hero-title">
        <div className="gallery-hero__overlay" />
        <div className="gallery-hero__content">
          <FadeContent className="space-y-6">
            <p className="gallery-hero__eyebrow">Réalisations signature</p>
            <h1 id="gallery-hero-title" className="gallery-hero__title">
              Des projets emblématiques qui impriment la différence
            </h1>
            <p className="gallery-hero__subtitle">
              Coverings XXL, branding institutionnel, supports événementiels haut de gamme : explorez une
              sélection de réalisations Digiprint qui témoignent de notre exigence créative et technique.
            </p>
          </FadeContent>
        </div>
      </section>

      <section className="gallery-carousel" aria-labelledby="gallery-carousel-title">
        <div className="gallery-carousel__header">
          <FadeContent className="space-y-4">
            <h2 id="gallery-carousel-title" className="gallery-carousel__title">
              Inspirations grand format
            </h2>
            <p className="gallery-carousel__description">
              Faites défiler la galerie pour découvrir cinq projets récents : covering de bus, branding événementiel
              et dispositifs premium réalisés pour nos partenaires institutionnels en Côte d’Ivoire.
            </p>
          </FadeContent>
        </div>
        <MediaCarousel
          items={realisationsSlides}
          autoplayDelay={4000}
          className="gallery-carousel__slider"
          rounded={false}
        />
        <FadeContent className="gallery-carousel__cta">
          <p className="gallery-carousel__cta-text">Un événement à venir ? Confiez-nous vos supports.</p>
          <Link to="/contact" className="btn-primary">
            Demander un devis
          </Link>
        </FadeContent>
      </section>
    </div>
  );
};

export default Gallery;
